/* global window */

import Vue from 'vue';
import _ from 'lodash';
import { mapState } from 'vuex';

// Template and media files
import './login.scss';
import template from './login.vhtml';
import logoAscanius from '../../../_img/logo.svg';
import logo from '../../../_img/logo-esbjerghavn.svg';

import $, { parseJSON } from 'jquery';

function doLogin(endpoint, data) {
	return $.ajax({
		method: 'post',
		data: data,
		url: `${appData.root}${endpoint}`,
		headers: { 'X-WP-Nonce': appData.nonce }
	});
}

(function (w) {

	w.URLSearchParams = w.URLSearchParams || function (searchString) {
		var self = this;
		self.searchString = searchString;
		self.get = function (name) {
			var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
			if (results == null) {
				return null;
			}
			else {
				return decodeURIComponent(results[1]) || 0;
			}
		};
		self.has = function (name) { var results = new RegExp('[\?&]' + name).exec(self.searchString); if (results == null) { return null; } else { return true; } }
	}

})(window)

export const LogIn = Vue.component('login', {
	components: {
		logo,
		logoAscanius
	},
	data() {
		return {
			credentials: [],
			userdata: {
				listings: [],
				categories: []
			},
			logo: logo,
			lAppInner: null,
			resetOnce: false,
			loading: false,
			errored: false,
			failed: false,
			success: false,
			redirect: '/',
			createUser: false,
			recoverPassword: false,
			recovercomplete: false,
			errormessage: '',
			appListings: appData.appListings,
			appCategories: appData.appCategories,
			loginImages: appData.loginImages
		}
	},
	template: template,
	props: {
		appLoaded: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		transition: vm => vm.$store.state.pages.transition,
		transitionMode: vm => vm.$store.state.pages.transitionMode,
		website: vm => vm.$store.state.appsData.data.website,
		...mapState({
			showSidebar: state => state.sidebar.showSidebar,
			isNavigating: state => state.pages.isNavigating,
		}),
	},
	watch: {
		content() {
			this.$store.commit('sidebar/updateData', {
				name: 'parent',
				value: '/',
			});
		}
	},
	methods: {
		handleSubmit: function (submitEvent) {
			this.loading = true
			this.errored = false
			this.failed = false

			//Make a request to WP
			let data = {
				username: this.credentials.username,
				password: this.credentials.password
			}
			doLogin('kla/v1/user/login/', data)
				.done(data => {
					this.loading = false

					if (typeof data.nonce !== 'undefined') {
						appData.nonce = data.nonce
					}

					if (data.loggedin) {
						appData.user = data.userdata
						localStorage.clear()
						this.navigateToIndex(this.redirect);
					}

					if (!data.loggedin) {
						this.failed = true
					}


				})
				.fail(data => {
					this.loading = false
					this.errored = true
				});

		},

		handleRecoverPassword: function (submitEvent) {
			this.loading = true
			this.errored = false
			this.failed = false

			//Make a request to WP
			let data = {
				username: this.credentials.username
			}
			doLogin('kla/v1/user/recoverpassword/', data)
				.done(data => {
					this.loading = false

					if (data.completed) {
						this.recovercomplete = true
					}
				})
				.fail(data => {
					this.loading = false
				});

		},

		handleUserCreate: function (submitEvent) {
			this.loading = true
			this.errored = false
			this.failed = false

			//Make a request to WP
			let data = {
				name: this.userdata.name,
				company: this.userdata.company,
				phone: this.userdata.phone,
				email: this.userdata.email,
				username: this.userdata.username,
				password: this.userdata.password,
				listings: this.userdata.listings,
				categories: this.userdata.categories
			}
			doLogin('kla/v1/user/create', data)
				.done(data => {
					this.loading = false

					if (data.created) {
						this.success = true
						this.failed = false
					}

					if (!data.created) {
						this.errored = true
						this.errormessage = data.errormessage
					}


				})
				.fail(data => {
					this.loading = false
					this.errored = true
				});

		},

		navigateLeft(to) {
			this.$store.commit('pages/updateData', {
				name: 'isNavigating',
				value: true,
			});
			this.$store.commit('pages/updateData', {
				name: 'transition',
				value: 'slide',
			});
			this.$nextTick(function () {
				this.$router.push({ path: to, query: '' });
			});
		},

		navigateToIndex(link, privacy) {
			if (!this.isLoggedIn && privacy === 'private') {
				link = '/log-in'
			}

			window.removeEventListener('scroll', this.$options.throttleFunction);
			this.$store.commit('sidebar/updateData', {
				name: 'transparentUntilLg',
				value: false,
			});
			this.$store.commit('sidebar/updateData', {
				name: 'stuckToTopMobile',
				value: false,
			});
			this.navigateLeft(link);
			setTimeout(() => {
				this.$store.commit('sidebar/updateData', {
					name: 'sidebarPos',
					value: 'left',
				});
			}, 100);
		},

		toogleSidebarTransparency() {
			if (this.$el.clientWidth < 754) {
				window.pageYOffset > 50 ? this.$store.commit('sidebar/updateData', {
					name: 'transparentUntilLg',
					value: false,
				}) : this.$store.commit('sidebar/updateData', {
					name: 'transparentUntilLg',
					value: true,
				})
			}
		}
	},
	created() {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);

		if (urlParams.has('redirect')) {
			this.redirect = urlParams.get('redirect')
		}

		this.$store.dispatch('pagination/hideRightAndThenMakeFullScreen');

		this.$store.commit('pagination/updateData', {
			name: 'fullWidthUntilLg',
			value: true,
		});

		this.$store.commit('sidebar/updateData', {
			name: 'transparentUntilLg',
			value: true,
		});

		this.$store.commit('sidebar/updateData', {
			name: 'stuckToTopMobile',
			value: true,
		});

		this.$store.commit('sidebar/updateData', {
			name: 'sidebarPos',
			value: 'left',
		});

		this.$nextTick(function () {
			this.$options.throttleFunction = _.throttle(this.toogleSidebarTransparency, 25);
			window.addEventListener('scroll', this.$options.throttleFunction);
		});
	},
	mounted() {
		setTimeout(() => {
			$('html').removeClass('no-scroll');
		}, 600)

		this.$store.commit('pages/updateData', {
			name: 'isNavigating',
			value: true,
		});

		setTimeout(() => {
			this.$store.commit('pages/updateData', {
				name: 'isNavigating',
				value: false,
			});

		}, 100);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.$options.throttleFunction);
	},
	beforeRouteLeave(to, from, next) {
		this.loading = true;
		this.resetOnce = false;
		to.params.transition = this.transition;
		setTimeout(() => {
			next();
		}, 100);
	}
});



// WEBPACK FOOTER //
// ./assets/_js/components/login/login.js